var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.number)?_c('span',[(_vm.country==='default')?_c('IdentityNumberDefault',{attrs:{"demographic":_vm.demographic,"number":_vm.number,"type":_vm.type}}):_vm._e(),(_vm.country==='ZA')?_c('IdentityNumberZa',{attrs:{"demographic":_vm.demographic,"number":_vm.number,"type":_vm.type}}):_vm._e()],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }